jQuery(document).ready(function(){

  //out of stock reminder
  $('#product-add').on('click','#ISR_button_remote',function(e){
      e.preventDefault();
  	  $('#ISR_button').click();

  })

  updateHoverCart();

jQuery(".mycartdrop").on('mouseenter focusin', function(){
   	jQuery("#mycartitems").css('overflow', 'visible');
  	jQuery("#mycartitems").css('overflow', 'hidden');
	jQuery("#cart-info").show();
});

jQuery(".mycartdrop").on('mouseleave focusout', function(e){
  // Keep open if focus moves within the cart dropdown
  if (e.type === 'focusout' && jQuery(e.relatedTarget).closest('.mycartdrop').length) return;
  jQuery("#mycartitems").css('overflow', 'hidden');
	jQuery("#cart-info").hide();
});



function updateHoverCart(){
	jQuery.getJSON('/cart.js', function (cart, textStatus) {

		if ((typeof callback) === 'function')
		{
		  callback(cart);
		}
		else
		{
			var item_count = cart['item_count'];

			if(item_count > 0) {
				jQuery("#cart-info").remove();
				var total_price = cart['total_price']/100;
				var h="<div id='cart-info'><table border='1'>";
              	h+="<button id='drop-cart-close' aria-label='Close cart preview' type='button'></button>";
				h+="<tr><td colspan='6' class='cart_header'>ITEMS IN YOUR CART</td></tr>";
              	h+="<tr><td colspan='6' id='items_container'><div id='mycartitems'><table>";
				var i = 1;
				jQuery.each( cart['items'], function( key, value ) {

					var pro_title = value['title'];
					var qty = value['quantity'];
					var pro_url = value['url'];
					var image_url = value['image'];
					var line_price = value['line_price']/100;
					var line_count = i;
                                        var product_type = value['product_type'];
                                  var variantID = value['variant_id'];
                  if(i==1){ ss = 'noBorder'; }
                  else{ss = 'ss'; }
		                  let formattedLinePrice = "&#36;" + line_price.toFixed(2);
                                  let removeLink = "<a class='cart_remove' href='/cart/change?line="+line_count+"&quantity=0'>REMOVE</a></td>";
                                  if (product_type == "Hidden" ) {
                                    qty = "";
                                    formattedLinePrice = "free";
                                    removeLink = "";
                                  }
                                  if (product_type == "Gift Wrap") {
                                    qty = "";
                                    removeLink = "";
                                  }                    
                  h+="<tr><td width='1%' class='"+ss+"'></td><td width='30%' class='"+ss+"'><a href='"+pro_url+"'><img src='"+image_url+"' alt='"+pro_title+"' style='width:100px;'></a></td><td>";
				  h+="<td width='50%' class='"+ss+"'><a href='"+pro_url+"' class='cart_pro_title'>"+pro_title+"</a><br/>" + removeLink;

					h+="<td width='8%' class='"+ss+"'>"+qty+"</td><td width='11%' class='"+ss+"'>"+formattedLinePrice;+"</td></tr>";

					i++;
				});
				//h+="<tr><td></td><td></td><td class='cart_subtotal'>SUBTOTAL</td><td></td><td><strong>&#36;"+total_price.toFixed(2)+"</strong></td><td></td></tr>";
				h+="</table></div></td></tr>";

              h+="<tr><td colspan='6' id='items_container1'><div id='mycartitems1'><table>";
              h+="<tr><td width='1%'>&nbsp;</td><td width='44%'>&nbsp;</td><td width='50%' class='cart_subtotal'>SUBTOTAL</td><td width='8%'></td><td width='11%'><strong>&#36;"+total_price.toFixed(2)+"</strong></td></tr>";
              h+="</table></div></td></tr>";


				h+="<tr><td colspan='6' style='text-align:center' id='cart_buttons_td'><div id='view_cart'><a href=\"/cart\">VIEW CART</a></div><div id='checkout_me'><a href=\"/checkout\">CHECKOUT</a></div></td></tr>";
				h+="<tr><td colspan='6' class='cart_footer'>FREE U.S. SHIPPING ON ORDERS &#36;75 +</td></tr>";

				h+="</table></div>";

				jQuery(".mycartdrop").append(h);
				jQuery("#cart-info").hide();
			}
		  //Shopify.onCartUpdate(cart);
		}
	});
}


   function addItem(form_id) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#'+form_id).serialize(),
        success: Shopify.onSuccess,
        error: Shopify.onError
      });
   }

   $(".addtocart, #pre-order").click(function(e){
      var checkSelect = $('.single-option-selector').val()
      if ( checkSelect == 'Select'){
        e.preventDefault();
        $('.single-option-selector').addClass('pick-option');
      }
     else {
      var elem = $(this)
      $(elem).prop("disabled", true)

      e.preventDefault();
      addItem('add-item-form');
       $('.single-option-selector').removeClass('pick-option');

       setTimeout(function(){updateHoverCart();},1000);
     }
   });

   Shopify.onSuccess = function() {

        var elem = $('.addtocart');


     	var quantity = parseInt(jQuery('[name="quantity"]').val(), 10) || 1;

        elem.removeAttr("disabled");

        // var cartCount =  parseInt($('#cart-count').text()) + quantity;

        // $('#cart-count').text(' ' + cartCount + " items");
        // $('#cart-status').text(cartCount + ' ' + (cartCount === 1 ? 'item' : 'items') + ' in your cart');

        var cartCount = parseInt($('#cart-count-text').text()) + quantity;
        $('#cart-count-text').text(' ' + cartCount + ' ' + (cartCount === 1 ? 'item' : 'items'));
        $('#cart-status').text(cartCount + ' ' + (cartCount === 1 ? 'item' : 'items') + ' in your cart');


     	window.scrollTo(100, 0);
     	setTimeout(function() {

          	setTimeout(function(){jQuery("#mycartitems").niceScroll({touchbehavior:false,cursorcolor:"#bfa378",cursoropacitymax:0.7,cursorwidth:6,background:"#dbcdb1",autohidemode:false}); },1000);
       		jQuery("#mycartitems").css('overflow', 'visible');
  			jQuery("#mycartitems").css('overflow', 'hidden');
            jQuery("#cart-info").show();
          	jQuery('#cart-info').css('z-index', '1000');
       		 }, 1000);

     	setTimeout(function() {
          jQuery("#mycartitems").css('overflow', 'hidden');
              jQuery("#cart-info").hide();
         	  jQuery('#cart-info').css('z-index', '-1');
       		 }, 100000);

     	/*
     	$('#buy-pop-up').fadeIn( 1000, function() {

        	setTimeout(function() {
              $('#buy-pop-up').fadeOut(800);
       		 }, 1500);
        });
     	*/

     	jQuery('#m-cart-count').addClass('active').text(cartCount);


       };

    setTimeout(function(){jQuery("#mycartitems").niceScroll({touchbehavior:false,cursorcolor:"#bfa378",cursoropacitymax:0.7,cursorwidth:6,background:"#dbcdb1",autohidemode:false}); },1000);

    Shopify.onError = function(XMLHttpRequest, textStatus) {
      // Shopify returns a description of the error in XMLHttpRequest.responseText.
      // It is JSON.
      // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      if (!!data.message) {
        alert(data.message + '(' + data.status  + '): ' + data.description);
      } else {
        alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
      }

      $('.addtocart').removeAttr("disabled");
    };

    Shopify.fullMessagesFromErrors = function(errors) {
      var fullMessages = [];
      jQuery.each(errors, function(attribute, messages) {
        jQuery.each(messages, function(index, message) {
          fullMessages.push(attribute + ' ' + message);
        });
      });
      return fullMessages;
    };

})

jQuery(document).ready(function(){

  if ( $('.slides li').size() > 1 ) {

    $('.flexslider').flexslider({
      animation: "slide",
      slideshow: true,
      animationDuration: 700,
      slideshowSpeed: 6000,
      animation: "fade",
      controlsContainer: ".flex-controls",
      controlNav: false,
      keyboardNav: true
    }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});

  }

  $("select.loc_on_change").change(function(){
  	if($(this).attr("value") == "#") return false;
  	window.location = $(this).attr("value");
  });

  
  var IE6 = false /*@cc_on || @_jscript_version < 5.7 @*/;
  if(IE6){
    if($("#placeholder img").width() > 360){
      $("#placeholder img").css('width', '360px');
    } else {
      $("#placeholder img").css('width', $("#placeholder img").width()+'px'); // restrict to initial width of image
    }
  } else {
    $("#placeholder img").css('maxWidth', $("#placeholder img").width()+'px'); // restrict to initial width of image
  }

  var pw = $("#placeholder img").width() + 8;
  $("#placeholder img").parents('div.featured').css('maxWidth', pw+'px'); // force IE to play nice
  
});

jQuery(document).ready(function($){

  $("a.zoom").fancybox({
    padding:0,
    'titleShow': false,
    overlayColor: '#000000',
    overlayOpacity: 0.2
  });

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
  $('#product .thumbs a').click(function(){
    
    $('#zoom-image').attr('href', $(this).attr('href'));
    return false;
  });

  // Focus is intentionally preserved on buttons and inputs for keyboard accessibility

  $("li.dropdown").hover(function(){
    if ($(window).width() <= 840) return;
    $(this).children('a').first().attr('aria-expanded', 'true');
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    if ($(window).width() <= 840) return;
    $(this).children('a').first().attr('aria-expanded', 'false');
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });

  // Keyboard support for desktop dropdown menus: show on focusin, hide when focus leaves
  $("li.dropdown").on('focusin', function(){
    if ($(window).width() <= 840) return;
    $(this).children('a').first().attr('aria-expanded', 'true');
    $(this).children('.dropdown').stop(true).show().css('opacity', 1.0);
  }).on('focusout', function(e){
    if ($(window).width() <= 840) return;
    if (!$(e.relatedTarget).closest('li.dropdown')[0]) {
      $(this).children('a').first().attr('aria-expanded', 'false');
      $(this).children('.dropdown').stop(true).animate({ opacity: 0.0 }, 200, function(){
        $(this).hide();
      });
    }
  });

  $('a[href^="#"]').bind('click.smoothscroll',function (e) {

    e.preventDefault();

    var target = this.hash,
        $target = $(target);
    /*
    $('html, body').stop().animate({
        'scrollTop': $target.offset().top
    }, 500, 'swing', function () {
        window.location.hash = target;
    });
    */
  });

  var tabs = $('ul.tabs > li > a');
  tabs.each(function(i) {
    jQuery(this).unbind('click.smoothscroll')
    .click(function(e) {
         var contentLocation = $(this).attr('href');
    	 if(contentLocation.charAt(0)=="#") {
  		tabs.removeClass('active');
  		$(this).addClass('active');
  		$(contentLocation).show().addClass('active').siblings().hide().removeClass('active');
    	 }
      return false;
    });
  });

}); // end document ready

/* jQuery css bezier animation support -- Jonah Fox */

;(function($){

  $.path = {};

  var V = {
    rotate: function(p, degrees) {
      var radians = degrees * Math.PI / 180,
        c = Math.cos(radians),
        s = Math.sin(radians);
      return [c*p[0] - s*p[1], s*p[0] + c*p[1]];
    },
    scale: function(p, n) {
      return [n*p[0], n*p[1]];
    },
    add: function(a, b) {
      return [a[0]+b[0], a[1]+b[1]];
    },
    minus: function(a, b) {
      return [a[0]-b[0], a[1]-b[1]];
    }
  };

  $.path.bezier = function( params, rotate ) {
    params.start = $.extend( {angle: 0, length: 0.3333}, params.start );
    params.end = $.extend( {angle: 0, length: 0.3333}, params.end );

    this.p1 = [params.start.x, params.start.y];
    this.p4 = [params.end.x, params.end.y];

    var v14 = V.minus( this.p4, this.p1 ),
      v12 = V.scale( v14, params.start.length ),
      v41 = V.scale( v14, -1 ),
      v43 = V.scale( v41, params.end.length );

    v12 = V.rotate( v12, params.start.angle );
    this.p2 = V.add( this.p1, v12 );

    v43 = V.rotate(v43, params.end.angle );
    this.p3 = V.add( this.p4, v43 );

    this.f1 = function(t) { return (t*t*t); };
    this.f2 = function(t) { return (3*t*t*(1-t)); };
    this.f3 = function(t) { return (3*t*(1-t)*(1-t)); };
    this.f4 = function(t) { return ((1-t)*(1-t)*(1-t)); };

    /* p from 0 to 1 */
    this.css = function(p) {
      var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4=this.f4(p), css = {};
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( this.p1[0]*f1 + this.p2[0]*f2 +this.p3[0]*f3 + this.p4[0]*f4 +.5 )|0;
      css.y = this.y = ( this.p1[1]*f1 + this.p2[1]*f2 +this.p3[1]*f3 + this.p4[1]*f4 +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };

  $.path.arc = function(params, rotate) {
    for ( var i in params ) {
      this[i] = params[i];
    }

    this.dir = this.dir || 1;

    while ( this.start > this.end && this.dir > 0 ) {
      this.start -= 360;
    }

    while ( this.start < this.end && this.dir < 0 ) {
      this.start += 360;
    }

    this.css = function(p) {
      var a = ( this.start * (p ) + this.end * (1-(p )) ) * Math.PI / 180,
        css = {};

      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( Math.sin(a) * this.radius + this.center[0] +.5 )|0;
      css.y = this.y = ( Math.cos(a) * this.radius + this.center[1] +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };

  $.fx.step.path = function(fx) {
    var css = fx.end.css( 1 - fx.pos );
    if ( css.prevX != null ) {
      $.cssHooks.transform.set( fx.elem, "rotate(" + Math.atan2(css.prevY - css.y, css.prevX - css.x) + ")" );
    }
    fx.elem.style.top = css.top;
    fx.elem.style.left = css.left;
  };

})(jQuery);
